import actionTypes from '../actions/actionTypes'
import confirmTypes from 'helpers/enums/confirmTypes'
import errorCodes from 'helpers/enums/errorCodes'
import sessionTypes from 'helpers/enums/sessionTypes'
import localErrorCodes from 'helpers/enums/errors/localErrorCodes'

const defaultState = {
	current: {
		search: {
			page: 0,
			more: true,
			state: 'init',
		},
		current_folder: {

		},
	},
	input_value: '',
	order_field: 0,
	folders: [],
	parents: [],
	folderUID: '0',
	folderName: '',
	canShareFolder: false,
	folderColor: '0',
	lessons: [],
	tipsAndTricks: [],
	codes: [],
	liveCodes: {
		activePins: [],
	},
	homeworkCodes: {
		activePins: [],
	},
	pending_lessons: [],
	name_folder_modal: {
		folderUID: '0',
		lesson: 0,
		value: '',
		status: '',
		message: '',
	},
	actualTimestamp: 0,
	confirmsVisited: [],
	confirms: [],
	goals: [],
}

function updateSearch(state, action) {
	return {
		...state,
		current: {
			...state.current,
			search: {
				...state.current.search,
				page: 0,
				more: true,
				state: 'searching',
			},
		},
		input_value: action.query,
		order_field: action.orderField,
	}
}

function setParams(state, action) {
	return {
		...setFolderData(state, action.folderUID),
		input_value: action.query,
		order_field: action.orderField,
	}
}

function setFolderData(state, folderUID) {
	return {
		...state,
		current: {
			...state.current,
			search: {
				...state.current.search,
				page: 0,
				more: true,
				state: 'init',
			},
		},
		lessons: [],
		folderUID,
		input_value: folderUID === '0' ? state.input_value : '',
	}
}

function updateParams(state, action) {
	return setFolderData(state, action.folderUID)
}

function resetFolderLessonsList(state) {
	const newState = {
		...state,
		current: {
			...state.current,
			search: {
				...state.current.search,
				page: 0,
				more: true,
			},
		},
		lessons: [],
	}

	return newState
}

function updateMyLibraryLessonsFetched(state, action) {
	const newArrayElements = action.lessonsData.result.entities.map(item => item.data.entityUID)

	const newState = {
		...state,
		pending_lessons: [...state.pending_lessons],
	}

	const newCurrent = {...state.current}
	if (action.lessonsData.result.page === '0') {
		newState.lessons = newArrayElements
	} else {
		const filteredElements = newArrayElements.filter(element => newState.lessons.indexOf(element) < 0)
		newState.lessons = [...newState.lessons, ...filteredElements]
	}

	const entitiesTips = action.lessonsData.result.entitiesTips || []
	newState.tipsAndTricks =
		entitiesTips.length > 0 ? entitiesTips.map(entity => entity.data.entityUID) : state.tipsAndTricks

	const newSearch = {...newCurrent.search}
	if (action.isFullPage) {
		newSearch.page = parseInt(action.lessonsData.result.page) + 1
	}
	newSearch.more = action.lessonsData.result.more
	newSearch.state = 'idle'
	newCurrent.search = newSearch
	newState.current = newCurrent

	action.lessonsData.result.entities.forEach(function(lesson) {
		if ((lesson.data.state === 5 || lesson.data.state === 2) &&
			newState.pending_lessons.indexOf(lesson.data.entityUID) === -1) {
			newState.pending_lessons.push(lesson.data.entityUID)
		}
	})

	return newState
}

function updateMyLibraryFoldersFetched(state, action) {
	return {
		...state,
		folders: action.foldersData.folders,
		parents: action.foldersData.parents,
		folderName: action.foldersData.name,
		folderColor: action.foldersData.color,
		canShareFolder: action.foldersData.canShareFolder,
	}
}

function updateSessionData(state, action) {
	if (action.payload.multiplePins || (action.payload.activePins && action.payload.activePins.length > 0)) {
		const newState = {...state}
		newState.codes = action.payload.activePins
		newState.actualTimestamp = action.payload.actualTimestamp
		return newState
	} else {
		const newState = {...state}
		const data = action.payload
		const code = {
			pincode: data.pincode,
			session_uid: data.session_uid,
			launched_time: data.launched_time,
			expire_time: data.expire_time,
			expiresIn: data.expiresIn,
			messages: data.messages,
			is_submission_required: data.is_submission_required,
		}
		newState.codes = [code]
		newState.actualTimestamp = data.actualTimestamp
		return newState
	}
}

function updateLessonCodes(state, action) {
	const newState = {...state}
	const liveCodes = action.payload.session[sessionTypes.LIVE_SESSION]
	if (liveCodes) {
		newState.liveCodes = liveCodes
	}

	const homeworkCodes = action.payload.session[sessionTypes.HOMEWORK]
	if (homeworkCodes) {
		newState.homeworkCodes = homeworkCodes
	}

	return newState
}

function setLiveCodes(state, action) {
	const newState = {...state}
	if (action.hasMultiplePins) {
		newState.codes = newState.liveCodes.activePins
		newState.actualTimestamp = newState.liveCodes.actualTimestamp
	}
	return newState
}

function resetLessonCodes(state) {
	return {
		...state,
		liveCodes: {
			activePins: [],
		},
		homeworkCodes: {
			activePins: [],
		},
	}
}

function removeLessonFromList(state, action) {
	return removeLesson(state, action.lesson.data.entityUID)
}

function removeLesson(state, entityUID) {
	const newState = {...state}
	newState.lessons = state.lessons.filter(lesson => lesson !== entityUID)
	return newState
}

function handleMoveLesson(state, action) {
	return removeLesson(state, action.lessonUID)
}

function removeFolder(state, action) {
	const newState = {...state}
	newState.folders = state.folders.filter(folder => folder.id !== action.folderID)
	return newState
}

function handleMyLibrarySaveChangesFetched(state, action) {
	if (action.saveResponse.error_code === 0) {
		return addToPendingLessons(state, action.saveResponse.id)
	} else {
		return state
	}
}

function addToPendingLessons(state, presentationId) {
	const newState = {
		...state,
		pending_lessons: [...state.pending_lessons, presentationId],
	}

	return newState
}

function updatePendingLessons(state, action) {
	const newState = {...state}

	// Saving all lessons from response in a dictionary to find them by key
	const lessons_hash = {}
	action.pending_lessons.forEach(elem => lessons_hash[elem.id] = elem)

	const newPendingLessons = state.pending_lessons.filter(id => {
		// If lesson is not in the dictionary means that the lesson was not part of the previous request.
		// Probably because it was saved after the previous request.
		// If lesson is in the dictionary and status is not 1 or has an error, lesson is not saved yet
		const lesson = lessons_hash[id]
		return !lesson
        || lesson.status === 2
        || lesson.status === 5
        || lesson.error_code !== 0
	})

	newState.pending_lessons = newPendingLessons

	return newState
}

function addNewFolder(state) {
	const newState = {
		...state,
		name_folder_modal: {
			...state.name_folder_modal,
			folderUID: '0',
			lesson: null,
			value: '',
			status: '',
			submitting: false,
		},
	}
	return newState
}

function addLessonToNewFolder(state, action) {
	const newState = addNewFolder(state)
	newState.name_folder_modal.lesson = action.lesson
	return newState
}

function renameFolder(state, action) {
	const newState = addNewFolder(state)
	newState.name_folder_modal.folderUID = action.folder
	newState.name_folder_modal.value = action.name
	return newState
}

function updateRenameFolderStatus(state, action) {
	if (action.error.error_code === 1) {
		return {
			...state,
			name_folder_modal: {
				...state.name_folder_modal,
				message: action.error.message,
				status: 'error',
				submitting: false,
			},
		}
	} else {
		return state
	}
}

function setFolderStatusAsUpdating(state) {
	return {
		...state,
		name_folder_modal: {
			...state.name_folder_modal,
			status: '',
			submitting: true,
		},
	}
}

function updateExpireTime(state, action) {
	return updateTime(state, action.sessionUid, action.newExpireTime)
}

function updateTime(state, sessionUid, expireTime) {
	return {
		...state,
		codes: state.codes.map(code => code.session_uid === sessionUid ? {...code, expire_time: expireTime } : code ),
	}
}

function updateRequiredSubmission(state, action) {
	return {
		...state,
		codes: state.codes.map(code => code.session_uid === action.sessionUid
			? {...code, is_submission_required: action.value }
			: code ),
	}
}

function restoreRequiredSubmission(state, action) {
	return {
		...state,
		codes: state.codes.map(code => code.session_uid === action.sessionUid ? {...code, is_submission_required: action.value === '1' ? '0' : '1'} : code ),
	}
}

function restoreExpireTime(state, action) {
	return updateTime(state, action.sessionUid, action.currentExpireTime)
}

function clearConfirm(state, confirmType) {
	return {
		...state,
		confirmsVisited: [...state.confirmsVisited, confirmType],
	}
}

function clearLtiConfirm(state) {
	return clearConfirm(state, confirmTypes.MY_LIBRARY_NO_LESSONS_LTI_CONFIRM)
}

function setGoalsData(state, action) {
	return {
		...state,
		goals: action.goals,
	}
}

function handleSessionLaunchFailed(state, action) {
	if (action.error.error_code === errorCodes.LESSON_LAUNCH_NOT_READY) {
		return {
			...state,
			confirms: [
				{
					type: confirmTypes.MY_LIBRARY_LESSON_LAUNCH_FAILED,
				},
			],
		}
	} else if (action.error.error_code === errorCodes.LESSON_WITH_COLLABORATE_SLIDES) {
		return {
			...state,
			confirms: [
				{
					type: confirmTypes.MY_LIBRARY_HOMEWORK_WITH_COLLABORATE_DISABLED,
					props: {
						presentationUid: action.presentationUid,
						isNew: action.isNew,
					},
				},
			],
		}
	} else {
		return state
	}
}

function handleEditLessonFailed(state, action) {
	if (action.payload.error_code === errorCodes.EXCEED_MAX_USER_STORAGE) {
		return {
			...state,
			confirms: [
				{
					type: confirmTypes.MY_LIBRARY_PAYWALL_STORAGE_CONFIRM,
					props: {
						message: action.payload.message,
						upgradeSource: action.upgradeSource,
					},
				},
			],
		}
	} else if (action.payload.error_code === errorCodes.EXCEED_MAX_PRESENTATION_SIZE) {
		return {
			...state,
			confirms: [
				{
					type: confirmTypes.PAYWALL_PRESENTATION_SIZE_CONFIRM,
					props: {
						message: action.payload.message,
						upgradeSource: action.upgradeSource,
					},
				},
			],
		}
	} else if (action.payload.error_code === localErrorCodes.GOOGLE_SLIDES_UNAUTHORIZED_USER) {
		return {
			...state,
			confirms: [
				{
					type: confirmTypes.GOOGLE_SLIDES_UNAUTHORIZED_USER_EDIT,
					props: {
						upgradeSource: action.upgradeSource,
						lessonData: action.lessonData,
					},
				},
			],
		}
	} else {
		return state
	}
}

function removeConfirm(state, confirmType) {
	return {
		...state,
		confirms: state.confirms.filter(confirm => confirm.type !== confirmType),
	}
}

const myLibraryReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.MY_LIBRARY_INITIALIZE:
			return setParams(state, action)
		case actionTypes.MY_LIBRARY_ROUTE_UPDATE:
			return updateParams(state, action)
		case actionTypes.MY_LIBRARY_SEARCH_LESSONS:
		case actionTypes.VIDEO_MY_VIDEOS_PICKER_QUERY_SEARCH:
			return updateSearch(state, action)
		case actionTypes.MY_LIBRARY_FIRST_LESSON_PRESENTATION_PUBLISHED:
		case actionTypes.ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_ADD_LESSON_COMPLETED:
		case actionTypes.MY_LIBRARY_LESSONS_PICKER_SAVE_LESSONS_SUCCESS:
		case actionTypes.VIDEO_MY_VIDEOS_PICKER_FINALIZED:
			return resetFolderLessonsList(state)
		case actionTypes.MY_LIBRARY_LESSONS_FETCHED:
			return updateMyLibraryLessonsFetched(state, action)
		case actionTypes.MY_LIBRARY_FOLDERS_FETCHED:
		case actionTypes.MY_LIBRARY_ADD_OR_UPDATE_FOLDER_SUCCESS:
		case actionTypes.MY_LIBRARY_CHANGE_FOLDER_COLOR_SUCCESS:
			return updateMyLibraryFoldersFetched(state, action)
		case actionTypes.MY_LIBRARY_SESSION_FETCHED:
		case actionTypes.MY_LIBRARY_HOMEWORK_FETCHED:
			return updateSessionData(state, action)
		case actionTypes.MY_LIBRARY_DELETE_LESSON_SUCCESS:
		case actionTypes.MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER_SUCCESS:
			return removeLessonFromList(state, action)
		case actionTypes.MY_LIBRARY_MOVE_LESSON:
			return handleMoveLesson(state, action)
		case actionTypes.MY_LIBRARY_MOVE_FOLDER:
			return removeFolder(state, action)
		case actionTypes.MY_LIBRARY_SAVE_CHANGES_FETCHED:
			return handleMyLibrarySaveChangesFetched(state, action)
		case actionTypes.MY_LIBRARY_PENDING_LESSONS_STATUS_FETCHED:
			return updatePendingLessons(state, action)
		case actionTypes.MY_LIBRARY_ADD_LESSON_TO_NEW_FOLDER:
			return addLessonToNewFolder(state, action)
		case actionTypes.MY_LIBRARY_ADD_FOLDER:
			return addNewFolder(state)
		case actionTypes.MY_LIBRARY_FOLDER_RENAME:
			return renameFolder(state, action)
		case actionTypes.MY_LIBRARY_ADD_OR_UPDATE_FOLDER_FAILED:
			return updateRenameFolderStatus(state, action)
		case actionTypes.MY_LIBRARY_ADD_OR_UPDATE_FOLDER:
			return setFolderStatusAsUpdating(state)
		case actionTypes.MY_LIBRARY_SESSION_CODE_SAVE_EXPIRATION_DATE:
			return updateExpireTime(state, action)
		case actionTypes.MY_LIBRARY_SESSION_CODE_SAVE_EXPIRATION_DATE_FAILED:
			return restoreExpireTime(state, action)
		case actionTypes.MY_LIBRARY_CLOSE_NO_LESSONS_LTI_CONFIRM:
			return clearLtiConfirm(state)
		case actionTypes.GOALS_FETCHED:
			return setGoalsData(state, action)
		case actionTypes.MY_LIBRARY_STUDENT_PACED_TOGGLE_REQUIRED_SUBMISSIONS:
			return updateRequiredSubmission(state, action)
		case actionTypes.MY_LIBRARY_STUDENT_PACED_TOGGLE_REQUIRED_SUBMISSIONS_FAILED:
			return restoreRequiredSubmission(state, action)
		case actionTypes.MY_LIBRARY_LIVE_SESSION_FAILED:
		case actionTypes.MY_LIBRARY_HOMEWORK_FAILED:
			return handleSessionLaunchFailed(state, action)
		case actionTypes.MY_LIBRARY_LESSON_LAUNCH_FAILED_CONFIRM_CLOSE:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_LESSON_LAUNCH_FAILED)
		case actionTypes.MY_LIBRARY_DUPLICATE_LESSON_FAILED:
		case actionTypes.MY_LIBRARY_EDIT_LESSON_FAILED:
			return handleEditLessonFailed(state, action)
		case actionTypes.MY_LIBRARY_PAYWALL_STORAGE_CONFIRM_CLOSE_SELECTED:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_PAYWALL_STORAGE_CONFIRM)
		case actionTypes.MY_LIBRARY_LAUNCH_HOMEWORK_COLLABORATE_DISABLED_OPEN_SETTINGS:
		case actionTypes.MY_LIBRARY_LAUNCH_HOMEWORK_COLLABORATE_DISABLED_LAUNCH:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_HOMEWORK_WITH_COLLABORATE_DISABLED)
		case actionTypes.MY_LIBRARY_TEACH_LESSON_SELECTED:
			return resetLessonCodes(state)
		case actionTypes.MY_LIBRARY_GET_ACTIVE_PINCODES_SUCCESS:
			return updateLessonCodes(state, action)
		case actionTypes.MY_LIBRARY_TEACH_LESSON_MODAL_LIVE_ACTIVE_CODES_SELECTED:
			return setLiveCodes(state, action)
		case actionTypes.PAYWALLS_PRESENTATION_SIZE_EXCEEDED_CONFIRM_CLOSE_SELECTED:
			return removeConfirm(state, confirmTypes.PAYWALL_PRESENTATION_SIZE_CONFIRM)
		case actionTypes.PAYWALLS_EDIT_GOOGLE_SLIDES_UNAUTHORIZED_CLOSE:
			return removeConfirm(state, confirmTypes.GOOGLE_SLIDES_UNAUTHORIZED_USER_EDIT)
		default:
			return state
	}
}

export default myLibraryReducer

export {
	defaultState,
	setGoalsData,
}
